import request from '@/utils/request'

let Training_positionsApi = {

  /*培训岗位列表*/
  list(data) {
    return request._post('/shop/plus.training_positions.Index/index', data);
},
/*添加培训岗位*/
add(data) {
    return request._post('/shop/plus.training_positions.Index/add', data);
},
/*修改培训岗位*/
edit(data) {
    return request._post('/shop/plus.training_positions.Index/edit', data);
},
/*删除培训岗位*/
del(data) {
    return request._post('/shop/plus.training_positions.Index/del', data);
},
/*培训岗位详情*/
detail(data) {
  return request._post('/shop/plus.training_positions.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.training_positions.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.training_positions.Setting/getSetting', data, errorback);
    },
}
export default Training_positionsApi;



// WEBPACK FOOTER //
// ./src/api/training_positions.js